import { render, staticRenderFns } from "./password-reset.vue?vue&type=template&id=2d291ca0"
import script from "./password-reset.js?vue&type=script&lang=js&external"
export * from "./password-reset.js?vue&type=script&lang=js&external"
import style0 from "./password-reset.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports